export default "__VITE_ASSET__CtQxWowL__"